import React, { Component } from 'react';
import queryString from 'qs';
import { toast } from 'react-toastify';
import { Modal } from 'carbon-components-react';
import { TableDefault } from '../../../../../components';
import { pathDmService } from '../../../../../services/Api';
import {
  PENDENTE,
  PREPARACAO,
  PRONTAENTREGA,
  ENTREGUE,
  CANCELADO,
} from '../../../../../config/StatusRequest';

class Items extends Component {
  constructor(props) {
    super(props);

    this.state = {
      actionModal: false,
      numberRequest: null,
      statusRequest: null,
      newStatusRequest: null,
      selectedFilter: null,
      dataRow: {},
      urlDelete: '/Pedido/DeleteItemPedido',
      urlEdit: '/admin/trade/brinde-detalhe/',
    };
  }

  setSatus = status => {
    let newStatus = {};
    switch (status) {
      case 'Indefinido':
        newStatus = PENDENTE;
        break;
      case 'Pendente':
        newStatus = PREPARACAO;
        break;
      case 'Preparação':
        newStatus = PRONTAENTREGA;
        break;
      case 'Pronto para Entrega':
        newStatus = ENTREGUE;
        break;
      case 'Entregue':
        newStatus = CANCELADO;
        break;
      default:
        newStatus = null;
        break;
    }

    this.setState({
      newStatusRequest: newStatus,
    });
  };

  actionNext = event => {
    this.setSatus(event.cells[5].value);
    this.setState(prevState => ({
      actionModal: !prevState.actionModal,
      selectedId: null,
      numberRequest: event.cells[1].value, // event.id,
      statusRequest: event.cells[5].value,
      dataRow: event,
    }));
  };

  closeModalNext = () => {
    this.setState({
      actionModal: false,
    });
  };

  updateStatusItem = async () => {
    const { dataRow, newStatusRequest } = this.state;

    const url = `/Pedido/AtualizaStatusItemPedido/${dataRow ? dataRow.id : null}?status=${
      newStatusRequest ? newStatusRequest.id : null
    }`;

    pathDmService(url, {})
      .then(async () => {
        toast.success('Status atualizado com sucesso.');
        await this.listRef.getItems();
        this.setState({ actionModal: false });
      })
      .catch(() => {
        toast.warn('Um erro inesperado ocorreu ao tentar atualizar o status.');
      });
  };

  render() {
    const {
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      dataFilter,
      selectedFilter,
      type,
      typeCleark,
      actionModal,
      numberRequest,
      statusRequest,
      newStatusRequest,
    } = this.state;
    const { defaultFilters, itemid } = this.props;
    // const orderStatus = data && data.status;
    const query = queryString.parse(defaultFilters);
    return (
      <div>
        <TableDefault
          search={search}
          onRef={ref => {
            this.listRef = ref;
          }}
          defaultFilters={defaultFilters}
          typeCleark={query.cancelados ? null : typeCleark}
          type={type}
          order={order}
          orderBy={orderBy}
          pageSize={pageSize}
          totalItems={totalItems}
          urlDelete={urlDelete}
          urlEdit={urlEdit}
          urlLoad={`/Pedido/GetBrindesAtendente/${itemid}`}
          actionNext={query.cancelados ? null : this.actionNext}
          idxStatus={4}
          dataFilter={dataFilter}
          selectedFilter={selectedFilter}
          {...this.props}
        />
        <Modal
          open={actionModal}
          onRequestSubmit={async () => this.updateStatusItem()}
          onRequestClose={() => this.closeModalNext()}
          modalHeading="Alteração de Status"
          primaryButtonText="Confirmar"
          secondaryButtonText="Cancelar"
        >
          <div>
            <p>
              Você tem certeza que deseja alterar o status do pedido 
              {' '}
              <br />
              <strong>{numberRequest}</strong>
              {' de'}
              <strong> 
                {' '}
                {statusRequest}
                {' '}
              </strong>
              {' para'} 
              {' '}
              <strong>{newStatusRequest ? newStatusRequest.value : null}</strong>
              {'?'}
            </p>
          </div>
        </Modal>
      </div>
    );
  }
}
export default Items;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Gifts/Detail/Items.js